const DirectionRotation = ({deviceDirection,tSize}) => {
    return(
        <div className={`back-board mobile_rotate ${deviceDirection==='port'?'active':''}`}  style={{position: 'absolute',width:tSize.w, height:tSize.h, left:tSize.l}}>
            <div className="mobile_rotate_inner_box">
                <h2><span>Welcome</span> To</h2>
                <img src="images/logo.png" alt="" className="mobile_logo w-100" />
                <img src="images/rotate.svg" alt="" className="rotate img-fluid mb-5 mt-4" />
                <p>Please rotate your device into landscape mode to explore the 2023 Therma-Tru Virtual Experience</p>
            </div>
        </div>
    )
}

export default DirectionRotation